import { useLocation, useNavigate } from "react-router";
import LinearProgress from "src/components/LinearProgress";
import { useAppSelector } from "src/store";
import { useGetByOrganizasyonIdQuery } from "../../services/Base/VeriKontrolApi";
import { useGetByLoginKimlikIdQuery } from "../../services/Genel/KimlikApi";
import { useGetVwKullaniciKontrolyetkiQuery, useGetVwKullaniciMenuyetkiQuery } from "../../services/Auth/KullaniciRolYetkiApi";
import { useGetAllParametersQuery } from "../../services/Base/ParametersApi";
import { useEffect, useState } from "react";
import { SignalRService, TerminalBilgiResponse } from "../../services/Printer/SignalRService";
import { useGetLanguageByNamespaceQuery, useLazyLocalesLoadQuery, useLocalesAddMutation } from "../../services/Base/LanguageApi";
import { useGetKullaniciPrinterQuery } from "../../services/Printer/PrinterApi";
import SnackbarUtils from "src/utils/SnackbarUtils";
import { useDispatch } from "react-redux";
import i18n from "src/i18n";
import { helper } from "src/utils/helper";
import { translate } from 'src/i18n/tHelper';

const translatePath = "pages|definitions";


const SessionQuerys = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { organizasyon } = useAppSelector(s => s.userOrganizasyon)
  const userState = useAppSelector(s => s.userLogin)
  const verikontrol = useGetByOrganizasyonIdQuery(organizasyon.bagliId, { skip: !organizasyon.bagliId })
  const kimlikState = useGetByLoginKimlikIdQuery(userState.userInfo?.kimlikId, { skip: !organizasyon.fkOrganizasyon })
  const menuAuth = useGetVwKullaniciMenuyetkiQuery(userState.userInfo?.id, { skip: !organizasyon.fkOrganizasyon })
  const controlAuth = useGetVwKullaniciKontrolyetkiQuery(userState.userInfo?.id, { skip: !organizasyon.fkOrganizasyon })
  const parameters = useGetAllParametersQuery(null, { skip: !organizasyon.fkOrganizasyon })
  const [terminal, setTerminal] = useState(new SignalRService())
  const langQuery = useGetLanguageByNamespaceQuery({ lang: localStorage.getItem("lang"), ns: "parameters" }, { skip: !parameters.data?.length })
  const [macAddr, setMacAddr] = useState<string>();//useGetPcInfoQuery(null, { skip: !organizasyon.fkOrganizasyon })
  const terminalData = useGetKullaniciPrinterQuery({
    kullaniciId: userState.userInfo?.id,
    macAddress: macAddr
  }, { skip: !macAddr })
  const [terminalOpen, SetTerminalOpen] = useState(false);

  //Terminalden Terminal bilgileri alınıyor
  const getTerminalInfo = async () => {
    try {
      await terminal.connect();
      await terminal.getTerimnalBilgi();
    } catch (error) {
      SnackbarUtils.info(
        translate(translatePath, 'Terminal Exe ile iletişim kurulamadı!')
      );
      SetTerminalOpen(true);
    }
  }
  useEffect(() => {
    if (terminal.hubConn.start) {
      terminal.hubConn.on("GetTerminalBilgiResponse", (response: TerminalBilgiResponse) => {
        setMacAddr(response?.macAdres[response.macAdres.length - 1])
        terminalData.refetch()
        terminal.disConnect()
      })
    }
  }, [terminal])
  //Terminalden Terminal bilgileri alındı  
  useEffect(() => {
    if (!!terminalData.data) {
      localStorage.setItem('barcodePrinter', terminalData.data[0]?.barcodePrinter);
      localStorage.setItem('laserPrinter', terminalData.data[0]?.lazerPrinter);
    }
  }, [terminalData])
  useEffect(() => {
    if (organizasyon.fkOrganizasyon > 0 && location?.pathname === '/') {
      getTerminalInfo();
      navigate('/duyuru');
    }
  }, [location?.pathname, navigate, organizasyon.fkOrganizasyon]);
  useEffect(() => {
    if (verikontrol?.data?.length > 0) {
      LisansKontrol();
    }
  }, [verikontrol.data]);

  const LisansKontrol = () => {
    var item = verikontrol.data.find(f => f.id === 1030);
    if (item) {
      if (item.deger === "E") {
        if (userState.userInfo.lisansGun <= helper.objectToNumber(item.kontrol))
          SnackbarUtils.warning(
            translate(translatePath, 'Lisans sürenizin dolmasına kalan süre: ') + userState.userInfo.lisansGun.toString() + translate(translatePath, 'Gün'))
        //"Lisans sürenizin dolmasına kalan süre: " + userState.userInfo.lisansGun.toString() + " Gün" )
      }
    }
  }

  const [loadLocales, loadLocalesState] = useLazyLocalesLoadQuery();
  const [addLocales] = useLocalesAddMutation();
  const [lang, setLang] = useState(localStorage.getItem('lang'));
  useEffect(() => {
    i18n
      .init({
        /** by default language is set to English */
        fallbackLng: false,
        fallbackNS: false,
        initImmediate: true,
        saveMissing: true,
        interpolation: {
          escapeValue: false
        },
        backend: {
          loadPath: (lng, ns) => "load/" + lng + "/" + ns,
          addPath: (lng, ns) => "add/" + lng + "/" + ns,
          allowMultiLoading: false,
          request: (options, url, payload, callback) => {
            if (!url)
              return;
            if (url.indexOf("load") === 0) {
              loadLocales({
                url
              }).unwrap()
                .then(res => {
                  callback(null, {
                    data: res,
                    status: 200
                  })
                })
                .catch(e => {
                  callback(e, {
                    data: e,
                    status: e.status
                  })
                })
            }
            if (url.indexOf("add") === 0) {
              addLocales({
                url,
                payload
              }).unwrap()
                .then(res => {
                  callback(null, {
                    data: res,
                    status: 200
                  })
                })
                .catch(e => {
                  callback(e, {
                    data: e,
                    status: e.status
                  })
                })
            }
          }
        },
        load: "all",
        keySeparator: '|',
        lng: lang,
        debug: false,
        react: {
          useSuspense: false
        }
      })
  }, [lang])

  return (
    <>
      {(
        loadLocalesState.isFetching
        || verikontrol.isFetching
        || kimlikState.isFetching
        || menuAuth.isFetching
        || controlAuth.isFetching
        || parameters.isFetching
        || langQuery.isFetching) ? <LinearProgress sx={{ p: 0 }} color="primary" />
        : props.children
      }
    </>
  );
};
export default SessionQuerys;